var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 1.6
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.481 15.5L15.481 23.5.499 23.5.499.5 23.472.5 23.472 15.5zM23.472 15.5L15.481 23.5",
    transform: "translate(-173 -670) translate(135 641) translate(26 16) translate(12.878 13) translate(1.5 .5)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M4.994 10l.999-1c.552-.552 1.445-.552 1.997 0 .553.552 1.446.552 1.998 0s1.445-.552 1.998 0c.552.552 1.445.552 1.997 0 .553-.552 1.445-.552 1.998 0 .552.552 1.445.552 1.997 0l1-1M4.994 15l.999-1c.552-.552 1.445-.552 1.997 0 .553.552 1.446.552 1.998 0",
    transform: "translate(-173 -670) translate(135 641) translate(26 16) translate(12.878 13) translate(1.5 .5)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote);
export default __webpack_public_path__ + "static/media/note.ac2de833.svg";
export { ForwardRef as ReactComponent };